import { apiFetch } from "#lib/api";

export async function fetchLogoutAccount() {
  const path = `/authentication/logout`;

  const result = await apiFetch<true>(path, { method: "POST"});

  return result;
}
